/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrImageColumn } from './igr-image-column';
import { ImageColumn } from './ImageColumn';
import { TypeRegistrar } from "igniteui-react-core";
var IgrImageColumnModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrImageColumnModule() {
    }
    IgrImageColumnModule.register = function () {
        TypeRegistrar.registerCons("IgrImageColumn", IgrImageColumn);
        TypeRegistrar.register("ImageColumn", ImageColumn.$type);
    };
    return IgrImageColumnModule;
}());
export { IgrImageColumnModule };
//# sourceMappingURL=igr-image-column-module.js.map
